/**
 * Frame for light-on-dark logos.
 * Converted from CSS `lab(35.6337% -1.58697 -10.8425)` (D65, sRGB) ≈ rgb(80, 89, 102).
 */
export const LIGHT_LOGO_FRAME_HEX = '#505966';

/** Use on React `style` for logo tiles when `isLight` (1px border + fill). */
export const lightLogoFrameBoxStyle = {
  borderWidth: 1,
  borderStyle: 'solid' as const,
  borderColor: LIGHT_LOGO_FRAME_HEX,
  backgroundColor: LIGHT_LOGO_FRAME_HEX,
};

/**
 * Tailwind: static arbitrary-value classes so JIT always picks them up.
 * Same color as {@link LIGHT_LOGO_FRAME_HEX}.
 */
export const LIGHT_LOGO_FRAME_TW =
  'border border-[#505966] bg-[#505966]' as const;
